module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/leather@3x_045409.jpg";